/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Empty_AskInputs */

const en_us2_search_preview_empty_ask = /** @type {(inputs: Search_Preview_Empty_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't find it? The last option is always to ask your trainer.`)
};

const pt_br2_search_preview_empty_ask = /** @type {(inputs: Search_Preview_Empty_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não achou? A última opção é sempre perguntar ao seu personal.`)
};

const es_419_search_preview_empty_ask = /** @type {(inputs: Search_Preview_Empty_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No lo encuentras? La última opción siempre es preguntarle a tu entrenador.`)
};

const pt_pt2_search_preview_empty_ask = /** @type {(inputs: Search_Preview_Empty_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não encontraste? A última opção é sempre perguntar ao teu treinador.`)
};

const fr_fr2_search_preview_empty_ask = /** @type {(inputs: Search_Preview_Empty_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introuvable ? La dernière option est toujours de demander à ton coach.`)
};

const de_de2_search_preview_empty_ask = /** @type {(inputs: Search_Preview_Empty_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht gefunden? Die letzte Option ist immer, deinen Coach zu fragen.`)
};

const it_it2_search_preview_empty_ask = /** @type {(inputs: Search_Preview_Empty_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non lo trovi? L'ultima opzione è sempre chiedere al tuo coach.`)
};

/**
* | output |
* | --- |
* | "Can't find it? The last option is always to ask your trainer." |
*
* @param {Search_Preview_Empty_AskInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_empty_ask = /** @type {((inputs?: Search_Preview_Empty_AskInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Empty_AskInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_empty_ask(inputs)
	if (locale === "es-419") return es_419_search_preview_empty_ask(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_empty_ask(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_empty_ask(inputs)
	if (locale === "de-DE") return de_de2_search_preview_empty_ask(inputs)
	if (locale === "it-IT") return it_it2_search_preview_empty_ask(inputs)
	return en_us2_search_preview_empty_ask(inputs)
});
export { search_preview_empty_ask as "search.preview_empty_ask" }